var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('iframe',{attrs:{"src":_vm.url,"width":"100%","height":"600"}})])}
var staticRenderFns = []

export { render, staticRenderFns }